export default __webpack_public_path__ + "static/media/icon_menu_buger_Open.98970f13.svg";